export default __webpack_public_path__ + "static/media/app.5bc0c5c0.less";